function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { saveAs } from 'file-saver';
import { loadPayment } from 'researcher/payment/actions';
import { loadUserInvoicingData } from 'researcher/user/actions';
import { convertDigitalOrderDisplayDetailsToJson } from 'shared/view/digital-order-conversion-service';
import * as c from './constants';
export var archiveDigitalTranslation = function archiveDigitalTranslation(digitalOrderIdentity, fileName) {
  var removeOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post("/api/digital-order/".concat(digitalOrderIdentity, "/archive"))).then(function () {
      if (removeOnSuccess) {
        dispatch(removeDigitalTranslation(digitalOrderIdentity));
      }
      dispatch(application.addMessage({
        type: 'success',
        message: '%(fileName)s deleted',
        params: {
          fileName: fileName
        }
      }));
    });
  };
};
export var removeDigitalTranslation = function removeDigitalTranslation(digitalOrderIdentity) {
  return {
    type: c.DIGITAL_TRANSLATION_ARCHIVED,
    digitalOrderIdentity: digitalOrderIdentity
  };
};
export var createDigitalOrder = function createDigitalOrder(digitalOrderUpdateRequest) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    dispatch({
      type: c.DIGITAL_ORDER_CREATION_REQUESTED
    });
    return dispatch(application.post('/api/digital-order/create', digitalOrderUpdateRequest)).then(function (json) {
      var error = json.error,
        type = json.type;
      if (error) {
        var params = JSON.parse(error.jsonEncodedParams || '{}');
        var message = error.error;
        if (message === 'digital-translations-word-count-exceeded') {
          dispatch({
            type: c.DIGITAL_ORDER_WORD_COUNT_EXCEEDED,
            fileIdentity: params.fileIdentity
          });
        } else if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: message,
            params: params
          }));
        }
      } else {
        var _ref3 = json.digitalOrders[0] || {},
          digitalPurchaseIdentity = _ref3.digitalPurchaseIdentity;
        dispatch({
          type: c.DIGITAL_ORDER_CREATED,
          digitalPurchaseIdentity: digitalPurchaseIdentity
        });
        dispatch(application.addMessage({
          type: 'success',
          message: "report_processing"
        }));
        if (searchOnSuccess) {
          dispatch(searchDigitalOrders({
            page: 1,
            type: type
          }));
        }
      }
      return json;
    });
  };
};
export var getDownloadUrl = function getDownloadUrl(digitalTranslationIdentity, fileName) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    var handleError = function handleError() {
      dispatch(application.addMessage({
        type: 'error',
        message: 'curie.file-archived'
      }));
      dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalTranslationIdentity: digitalTranslationIdentity
      });
    };
    var processResponse = function processResponse(response) {
      if (response.type === 'application/json') {
        throw new Error();
      }
      saveAs(response, fileName);
    };
    dispatch({
      type: c.DOWNLOAD_URL_REQUESTED,
      digitalTranslationIdentity: digitalTranslationIdentity
    });
    return dispatch(application.req({
      url: "/api/digital-order/".concat(digitalTranslationIdentity, "/download"),
      method: 'get',
      responseType: 'blob',
      timeout: 0,
      validateStatus: function validateStatus(status) {
        return status === 200 || status === 404;
      }
    })).then(processResponse).then(function () {
      return dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalTranslationIdentity: digitalTranslationIdentity
      });
    }).catch(handleError);
  };
};

// USED BY RUBRIQ
export var loadDigitalOrderDisplayDetails = function loadDigitalOrderDisplayDetails() {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    dispatch(loadUserInvoicingData());
    dispatch(loadPayment());
    return dispatch(application.get('/api/digital-order/load')).then(function (json) {
      var _convertDigitalOrderD = convertDigitalOrderDisplayDetailsToJson(json),
        availableDigitalTranslationPurchases = _convertDigitalOrderD.availableDigitalTranslationPurchases,
        digitalTranslationPurchases = _convertDigitalOrderD.digitalTranslationPurchases,
        hasUploadedDigitalEdit = _convertDigitalOrderD.hasUploadedDigitalEdit,
        hasUploadedDigitalTranslation = _convertDigitalOrderD.hasUploadedDigitalTranslation,
        numberOfUsesAvailable = _convertDigitalOrderD.numberOfUsesAvailable;
      dispatch({
        availableDigitalTranslationPurchases: availableDigitalTranslationPurchases,
        digitalTranslationPurchases: digitalTranslationPurchases,
        hasUploadedDigitalEdit: hasUploadedDigitalEdit,
        hasUploadedDigitalTranslation: hasUploadedDigitalTranslation,
        numberOfUsesAvailable: numberOfUsesAvailable,
        type: c.DIGITAL_ORDERS_DISPLAY_UPDATED
      });
    });
  };
};

// USED BY RUBRIQ
export var searchDigitalOrders = function searchDigitalOrders() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    dispatch({
      type: c.DIGITAL_ORDER_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/digital-order/search', data)).then(function (json) {
      var digitalOrders = json.results,
        pagination = json.pagination;
      dispatch({
        type: c.DIGITAL_ORDER_SEARCH_COMPLETED,
        pagination: pagination,
        digitalOrders: digitalOrders
      });
      return digitalOrders;
    });
  };
};

// USED BY RUBRIQ
export var updateDisplayedDigitalOrders = function updateDisplayedDigitalOrders() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.get('/api/digital-order/search', data)).then(function (json) {
      var digitalOrders = json.results;
      var keyedDigitalOrders = digitalOrders.reduce(function (kdo, digitalOrder) {
        return _objectSpread(_objectSpread({}, kdo), {}, _defineProperty({}, digitalOrder.identity, digitalOrder));
      }, {});
      dispatch({
        type: c.DIGITAL_ORDERS_UPDATED,
        digitalOrders: keyedDigitalOrders
      });
      return true;
    });
  };
};
export var grantChineseDigitalTranslationCredit = function grantChineseDigitalTranslationCredit(language, userIdentity) {
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    return dispatch(application.post("/api/".concat(userIdentity, "/chinese-digital-trial"), {})).then(function (data) {
      if (data.eligible) {
        dispatch(application.addMessage({
          type: 'success',
          message: 'free-chinese-digital-translation-credit-success'
        }));
      } else {
        dispatch(application.addMessage({
          type: 'error',
          message: 'free-chinese-digital-translation-credit-error'
        }));
      }
    });
  };
};